import React, { memo } from 'react';
import { v1 as uuid } from 'uuid';
import {
  getIn,
  Field,
  connect as connectFormik,
  FieldProps,
  FormikProps,
} from 'formik';
import Select from 'components/Select';
import Input from 'components/Input';
import { IOption } from 'components/Select/Select';
import { TextFieldsWrapper } from './styles';
import { IFormValues, ITextQuestionView } from 'store/survey/surveyTypes';
import i18n from '../../../../../../../i18n';

interface IFormikConnect {
  formik: FormikProps<IFormValues>;
}

interface IOwnProps {
  maxLength: ITextQuestionView['maxLength'];
  inputType: ITextQuestionView['inputType'];
}

type IComponentProps = IOwnProps & IFormikConnect;

const maxLengthId = uuid();
const withOutLength = ['data', 'phone', 'map'];
const TextFieldsEditor: React.FC<IComponentProps> = ({
  formik: { values },
}) => {
  const inputTypes: { [key in IComponentProps['inputType']]: IOption } = {
    text: { value: 'text', label: i18n.t('text', { ns: 'survey' }) as string },
    number: {
      value: 'number',
      label: i18n.t('number', { ns: 'survey' }) as string,
    },
    digits: {
      value: 'digits',
      label: i18n.t('digits', { ns: 'survey' }) as string,
    },
    date: { value: 'date', label: i18n.t('date', { ns: 'survey' }) as string },
    duration: {
      value: 'duration',
      label: i18n.t('duration', { ns: 'survey' }) as string,
    },
    dateAndTime: {
      value: 'dateAndTime',
      label: i18n.t('dateAndTime', { ns: 'survey' }) as string,
    },
    phone: {
      value: 'phone',
      label: i18n.t('phone', { ns: 'survey' }) as string,
    },
    area: { value: 'area', label: i18n.t('area', { ns: 'survey' }) as string },
    rich: { value: 'rich', label: i18n.t('rich', { ns: 'survey' }) as string },
    map: { value: 'map', label: i18n.t('map', { ns: 'survey' }) as string },
    inid: { value: 'inid', label: i18n.t('inid', { ns: 'survey' }) as string },
    none: { value: 'none', label: i18n.t('none', { ns: 'survey' }) as string },
  };
  const inputType: ITextQuestionView['inputType'] = getIn(
    values.data as ITextQuestionView,
    ['inputType']
  );

  return (
    <TextFieldsWrapper>
      <Field name="data.inputType">
        {({ form, field }: FieldProps) => (
          <Select
            label={i18n.t('inputTypeLabel', { ns: 'survey' }) as string}
            values={[inputTypes[field.value]]}
            options={Object.values(inputTypes)}
            onChangeValues={(types) => {
              const typeValue = types[0]
                ? types[0].value
                : inputTypes.text.value;
              form.setFieldValue('data.inputType', typeValue);
              // TODO: delete this after resolved on server
              if (typeValue === 'phone' || typeValue === 'date') {
                form.setFieldValue('data.maxLength', 0);
              }
            }}
          />
        )}
      </Field>
      {!withOutLength.includes(inputType) && (
        <Field name="data.maxLength">
          {({ field }: FieldProps) => (
            <Input
              {...field}
              id={maxLengthId}
              min={0}
              type="number"
              label={i18n.t('maxLengthLimitation', { ns: 'survey' }) as string}
              autoComplete="off"
            />
          )}
        </Field>
      )}
    </TextFieldsWrapper>
  );
};

export default memo(connectFormik<any, IFormValues>(TextFieldsEditor));
